module.exports = __webpack_public_path__ + "img/measurement_info_back_top.3d0afa99.jpg";